import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Certificado } from 'src/app/models/Certificado.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'certificados'); // La URL base para el servicio de usuarios
  }

  getCertificados(idUsuario: string) {
      return this.get<any>({endpoint: `/${idUsuario}`});  
  }

 
  create(data: any, trackLoading = true): Observable<Certificado> {
    return this.post<Certificado>(data, '', undefined, trackLoading);
  }

  putPasswordUanataca(payload: any, id: number) {
    return this.put<any>(payload,`/${id}/password/uanataca`,undefined,true 
    );
  }
  
  deleteCertificate(id:any,trackLoading = true): Observable<Certificado> {    
    return this.delete<any>(`/${id}`, undefined, undefined, trackLoading);
  }

}